import { makeStyles } from '@material-ui/core';

export default makeStyles({
  right: {
    display: 'none',
    '@media screen and (width >= 1024px)': {
      display: 'inline-block',
    },
  },
  check: {
    fontSize: '0.75rem',
    '@media screen and (width >= 1024px)': {
      display: 'none',
    },
  },
});
